<template>
  <div id="app">
    <component :is="layout">
    <!-- <img src="./assets/logo.png"> -->
      <router-view/>
    </component>
  </div>
</template>

<script>
export default {
  /* eslint-disable */
  name: 'App',
  data(){
    return{

    }
  },
  mounted() {
    console.log("初次进来",this.$route.meta.layout);
  },
  computed:{
      layout(){
        console.log("返回layout", this.$route.meta.layout)
        if (this.$route.meta.layout == ''){
          return "wx"
        }
        return this.$route.meta.layout
      }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue